import { render } from "./MbaMarketing.vue?vue&type=template&id=3965d0b2"
import script from "./MbaMarketing.vue?vue&type=script&lang=js"
export * from "./MbaMarketing.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__